import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timesheet-show" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Er zijn op dit project geen medewerkers van u geregistreerd. U kunt daar dus ook geen uren en materiaal voor registreren.", -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", null, "Uren", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "Weet je zeker dat je deze uren wilt verwijderen?", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h4", null, "Materialen", -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", null, "Weet je zeker dat je deze materialen wilt verwijderen?", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Locatie", -1)

import { computed, onMounted, ref } from 'vue'
import axios from 'axios'
import { useRoute, useRouter } from 'vue-router'
import { authStore } from '@/stores/auth'
import { PlusOutlined, CloseOutlined, DeleteOutlined } from '@ant-design/icons-vue'
import { notification } from 'ant-design-vue'
import PageTitleBar from '@/components/PageTitleBar.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectTimesheet',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const loading = ref(false)

const timesheet = ref<{ id:number, project_id:number, date:string, year_week:string, status:number }|null>(null)
const constructionWorkers = ref<{ id:number, firstname:string, lastname:string }[]|null>(null)
const activities = ref<Record<string, []>>({ hourly: [], material: [] })

const showActivityModal = ref(false)
const activityModalType = ref('hourly')
const timesheetEntry = ref<{ timesheet_id:number|null, construction_worker_id:number|null, activity_id:number|null, amount:number, location:string|null }>({
  timesheet_id: null,
  construction_worker_id: null,
  activity_id: null,
  amount: 0,
  location: null
})

const activityUnit = computed(() => {
  let unit = ''
  if (timesheetEntry.value.activity_id) {
    activities.value[activityModalType.value].forEach((a:{ id:number, unit:string }) => {
      if (timesheetEntry.value.activity_id === a.id) {
        unit = a.unit
      }
    })
  }

  return unit
})

const dateAndWeek = computed(() => {
  if (timesheet.value) {
    const date = new Date(timesheet.value.date).toLocaleDateString('nl-NL', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
    return date.charAt(0).toUpperCase() + date.slice(1) + ' - Week ' + timesheet.value.year_week.toString().substring(4, 6)
  } else {
    return 'Aan het laden..'
  }
})

onMounted(() => {
  getTimesheet()
  getActivities()
})

function getTimesheet () : void {
  loading.value = true
  axios.get(process.env.VUE_APP_API_URL + '/timesheets/' + route.params.timesheetId).then((r) => {
    timesheet.value = r.data.data
    getConstructionWorkers()
  }).catch(() => {
    notification.error({
      message: 'Fout tijdens ophalen van weekrapport.',
      description: 'Er is iets mis gegaan. Probeer het later nog een keer.',
      duration: 0
    })
  })
}

function getConstructionWorkers () : void {
  if (timesheet.value) {
    let query = '/constructionWorkers?filter[hasRegistrationOnProjectId]=' + timesheet.value.project_id + '&filter[company.id]=' + authStore().user.company_id + '&sort=firstname&limit=250'

    if (timesheet.value.status === 2) {
      query = '/constructionWorkers?filter[withInactive]=1&filter[hasRegistrationOnProjectId]=' + timesheet.value.project_id + '&filter[company.id]=' + authStore().user.company_id + '&sort=firstname&limit=250'
    }

    axios.get(process.env.VUE_APP_API_URL + query).then((r) => {
      constructionWorkers.value = r.data.data
    }).catch(() => {
      notification.error({
        message: 'Fout tijdens ophalen van medewerkers.',
        description: 'Er is iets mis gegaan. Probeer het later nog een keer.',
        duration: 0
      })
    }).finally(() => {
      loading.value = false
    })
  }
}

function getActivities () : void {
  axios.get(process.env.VUE_APP_API_URL + '/timesheets/activities').then((r) => {
    activities.value.hourly = r.data.hourly
    activities.value.material = r.data.material
  })
}

function toggleActivityModal (type:string|null, cwId = 0) : void {
  if (type) {
    showActivityModal.value = true
    activityModalType.value = type

    if (timesheet.value) {
      timesheetEntry.value.timesheet_id = timesheet.value.id
      timesheetEntry.value.construction_worker_id = cwId
      timesheetEntry.value.amount = type === 'hourly' ? 8 : 0
    }
  } else {
    showActivityModal.value = false
    activityModalType.value = 'hourly'
    timesheetEntry.value = {
      timesheet_id: null,
      construction_worker_id: null,
      activity_id: null,
      amount: 0,
      location: null
    }
  }
}

function addTimesheetEntry () : void {
  axios.post(process.env.VUE_APP_API_URL + '/timesheets/entries', timesheetEntry.value).then((r) => {
    timesheet.value = r.data.data
    notification.success({
      message: (activityModalType.value === 'hourly' ? 'Uren' : 'Materiaal') + ' toegevoegd.',
      description: (activityModalType.value === 'hourly' ? 'De uren' : 'De materialen') + ' zijn succesvol toegevoegd.',
      duration: 5
    })
    toggleActivityModal(null)
  }).catch(() => {
    notification.error({
      message: (activityModalType.value === 'hourly' ? 'Uren' : 'Materiaal') + ' NIET toegevoegd.',
      description: (activityModalType.value === 'hourly' ? 'De uren' : 'De materialen') + ' zijn NIET toegevoegd. Probeer het later nog een keer.',
      duration: 0
    })
  })
}

function destroyEntry (id:number, type:string) : void {
  if (timesheet.value) {
    axios.delete(process.env.VUE_APP_API_URL + '/timesheets/' + timesheet.value.id + '/entries/' + id).then((r) => {
      timesheet.value = r.data.data
      notification.success({
        message: (type === 'hourly' ? 'Uren' : 'Materiaal') + ' verwijderd.',
        description: (type === 'hourly' ? 'De uren' : 'De materialen') + ' zijn succesvol verwijderd.',
        duration: 5
      })
    })
  }
}

function filterItems (input:string, item:{ key:string, value:number }) {
  return item.key.toLowerCase().indexOf(input.toLowerCase()) >= 0
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageTitleBar, null, _createSlots({
      buttons: _withCtx(() => [
        _createVNode(_component_a_button, {
          style: {"float":"right"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'ProjectTimesheets', params: { projectId: timesheet.value.project_id } })))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Terug naar project")
          ]),
          _: 1
        })
      ]),
      _: 2
    }, [
      (timesheet.value)
        ? {
            name: "title",
            fn: _withCtx(() => [
              _createTextVNode("Urenregistratie - " + _toDisplayString(timesheet.value.project.name) + " (" + _toDisplayString(timesheet.value.project.reference) + ").", 1)
            ]),
            key: "0"
          }
        : {
            name: "title",
            fn: _withCtx(() => [
              _createTextVNode("Aan het laden..")
            ]),
            key: "1"
          },
      (timesheet.value)
        ? {
            name: "subtitle",
            fn: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(dateAndWeek)), 1)
            ]),
            key: "2"
          }
        : undefined
    ]), 1024),
    (!constructionWorkers.value || !constructionWorkers.value.length)
      ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_card, {
                  title: !constructionWorkers.value ? 'Aan het laden..' : 'Geen medewerkers gevonden voor dit project!',
                  loading: !constructionWorkers.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_2
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["title", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(constructionWorkers.value, (cw) => {
            return (_openBlock(), _createBlock(_component_a_row, {
              key: cw.id
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_card, null, _createSlots({
                      title: _withCtx(() => [
                        _createTextVNode(_toDisplayString(cw.firstname) + " " + _toDisplayString(cw.lastname), 1),
                        (!cw.active)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, " - Uit dienst"))
                          : _createCommentVNode("", true)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 11 }, {
                              default: _withCtx(() => [
                                _hoisted_5,
                                (timesheet.value.entries['cw' + cw.id] && timesheet.value.entries['cw' + cw.id].hourly && timesheet.value.entries['cw' + cw.id].hourly.length)
                                  ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_col, { span: 24 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_list, {
                                              "item-layout": "horizontal",
                                              "data-source": timesheet.value.entries['cw' + cw.id].hourly
                                            }, {
                                              renderItem: _withCtx(({ item }) => [
                                                _createVNode(_component_a_list_item, null, {
                                                  actions: _withCtx(() => [
                                                    (timesheet.value.status === 1)
                                                      ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                                                          key: 0,
                                                          placement: "bottomRight",
                                                          "ok-text": "Ja",
                                                          "cancel-text": "Nee",
                                                          onConfirm: ($event: any) => (destroyEntry(item.id, 'hourly'))
                                                        }, {
                                                          title: _withCtx(() => [
                                                            _hoisted_8
                                                          ]),
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_a_button, { size: "small" }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_unref(DeleteOutlined))
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onConfirm"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_list_item_meta, null, {
                                                      title: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.activity.name), 1)
                                                      ]),
                                                      description: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.amount) + " " + _toDisplayString(item.activity.unit), 1),
                                                        (item.location)
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                                              _hoisted_7,
                                                              _createTextVNode(_toDisplayString(item.location), 1)
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["data-source"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : (_openBlock(), _createBlock(_component_a_row, { key: 1 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_col, { span: 24 }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Er zijn (nog) geen uren geregistreerd voor deze medewerker. ")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_a_col, {
                              span: 11,
                              offset: 2
                            }, {
                              default: _withCtx(() => [
                                _hoisted_9,
                                (timesheet.value.entries['cw' + cw.id] && timesheet.value.entries['cw' + cw.id].material && timesheet.value.entries['cw' + cw.id].material.length)
                                  ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_col, { span: 24 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_list, {
                                              "item-layout": "horizontal",
                                              "data-source": timesheet.value.entries['cw' + cw.id].material
                                            }, {
                                              renderItem: _withCtx(({ item }) => [
                                                _createVNode(_component_a_list_item, null, {
                                                  actions: _withCtx(() => [
                                                    (timesheet.value.status === 1)
                                                      ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                                                          key: 0,
                                                          placement: "bottomRight",
                                                          "ok-text": "Ja",
                                                          "cancel-text": "Nee",
                                                          onConfirm: ($event: any) => (destroyEntry(item.id, 'material'))
                                                        }, {
                                                          title: _withCtx(() => [
                                                            _hoisted_12
                                                          ]),
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_a_button, { size: "small" }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_unref(DeleteOutlined))
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onConfirm"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_list_item_meta, null, {
                                                      title: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.activity.name), 1)
                                                      ]),
                                                      description: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.amount) + " " + _toDisplayString(item.activity.unit), 1),
                                                        (item.location)
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                                              _hoisted_11,
                                                              _createTextVNode(_toDisplayString(item.location), 1)
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["data-source"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : (_openBlock(), _createBlock(_component_a_row, { key: 1 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_col, { span: 24 }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Er zijn (nog) geen materialen geregistreerd voor deze medewerker. ")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, [
                      (timesheet.value && timesheet.value.status === 1)
                        ? {
                            name: "extra",
                            fn: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                style: {"margin-right":"8px"},
                                onClick: ($event: any) => (toggleActivityModal('hourly', cw.id))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(PlusOutlined)),
                                  _createTextVNode(" Uren")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_a_button, {
                                onClick: ($event: any) => (toggleActivityModal('material', cw.id))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(PlusOutlined)),
                                  _createTextVNode(" Materiaal")
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ])),
    _createVNode(_component_a_modal, {
      title: "Titel",
      visible: showActivityModal.value,
      onOk: addTimesheetEntry,
      onCancel: _cache[4] || (_cache[4] = ($event: any) => (toggleActivityModal(null)))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, _toDisplayString(activityModalType.value === 'hourly' ? 'Activiteit' : 'Materiaal'), 1),
                _createVNode(_component_a_select, {
                  "filter-option": filterItems,
                  value: timesheetEntry.value.activity_id,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((timesheetEntry.value.activity_id) = $event)),
                  "show-search": ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activities.value[activityModalType.value], (a) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: a.id,
                        key: a.name
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(a.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, "Aantal " + _toDisplayString(_unref(activityUnit)), 1),
                _createVNode(_component_a_input, {
                  type: "number",
                  value: timesheetEntry.value.amount,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((timesheetEntry.value.amount) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (activityModalType.value === 'material')
          ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _hoisted_13,
                    _createVNode(_component_a_input, {
                      type: "text",
                      value: timesheetEntry.value.location,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((timesheetEntry.value.location) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})